import React, { useCallback, useContext, useMemo } from "react";
import { Authentication } from "carynhealth-component-library";
import { useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AuthenticationType } from "carynhealth-component-library/dist/cjs/components/Authentication/interface";
import { authenticationProps } from "./data";
import StyleWrapper from "./style";
import config from "../../config/constants/config";
import { getRoutePaths } from "../../config/constants/routePaths";
import { AuthContext, AuthInfoType } from "../../context/AuthenticateContext";
import { getEnrolledMemberDataAPI } from "../../UI/HippaCard/handlers";
import { getIdCardDetails } from "../../config/routes/handlers";
import {
  getLoginCount
} from "../../UI/dashboard/handler";
import { setLocalStorage } from "carynhealth-component-library/dist/cjs/helpers/storage";

const brand = config.APP_NAME;

const Login: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const auth = useContext(AuthContext);

  const authenticate = useCallback(
    async (authenticateInfo: { authenticatedUser: AuthInfoType }) => {
       auth.updateAuthenticateInfo({
         ...(authenticateInfo?.authenticatedUser ?? auth.authenticatedInfo),
         isAuthenticated: true,
	       });
      // console.log("authenticateInfo", authenticateInfo)
      idcardData(authenticateInfo?.authenticatedUser?.email)
      // navigate(getRoutePaths.dashboard);
      getLoginCountByApi();
    },
    []
  );
  const findLastAuthUser = () => {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.endsWith(".LastAuthUser")) {
        return localStorage.getItem(key);
      }
    }
    return null; // Return null if not found
  };
  const findUserData = () => {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.endsWith(".userData")) {
        return localStorage.getItem(key);
      }
    }
    return null; // Return null if not found
  };
  const getLoginCountByApi = () => {
    const lastAuthUser = findLastAuthUser(); // Function from my previous response
    console.log("Last Authenticated User:", lastAuthUser);
    setLocalStorage("cognitoUsername", lastAuthUser||"");
    let userData = findUserData(); // Function from my previous response
    let parsedUserData = userData ? JSON.parse(userData) : null;
    setLocalStorage("contactNumber", parsedUserData?.UserAttributes.find((attr: { Name: string; }) => attr.Name === "phone_number")?.Value);
    localStorage.setItem(
      "subscriberName",
      parsedUserData?.UserAttributes.find((attr: { Name: string; }) => attr.Name === "name")?.Value
    );
    let data = getLoginCount();
    console.log(data);
    };
  const idcardData = async (email: string) => {
    await getIdCardDetails(email).then(async (data: any) => {
      let authInfo = {
        ...auth.authenticatedInfo,
        email: email,
        isAuthenticated: true,
        throughEmail: true,
      };
      localStorage.setItem("planId", data.apiResponse.memberIdCardList[0].planId)
      await getEnrolledMemberDataAPI(data.apiResponse.memberIdCardList[0].memberId)
      .then((res: any) => {
        authInfo = {
          ...authInfo,
          name:`${res.apiResponse[0]?.prefix || ''} ${res.apiResponse[0].firstName || ''} ${res.apiResponse[0]?.middleName || ''} ${res.apiResponse[0].lastName || ''} ${res.apiResponse[0]?.suffix || ''}`.trim().replace(/\s+/g, ' ')
        }
      })
      .catch((error) => {
        console.log(error);
      });   
      auth.updateAuthenticateInfo(authInfo || auth.authenticatedInfo);
      localStorage.setItem(
        "subscriberName",
        authInfo.name
      );
      navigate({
        pathname: getRoutePaths.dashboard,
      });
    });
  };

  const authenticateDetails = useMemo(
    () => authenticationProps({ isSmallScreen }),
    [isSmallScreen]
  );

  return (
    <StyleWrapper className={`login-${brand}`}>
      <Authentication
        {...(authenticateDetails as AuthenticationType)}
        authCallback={authenticate}
      />
    </StyleWrapper>
  );
};

export default Login;
